const AccountLimitsValidationService = require('./AccountLimitsValidationService');
const { errors } = require('@transfeeradev/api-enums');

class TransferValueValidationService extends AccountLimitsValidationService {
  constructor(args = {}) {
    super(args, {
      MAX_VALUE: errors.ptBr.tra.MAX_VALUE,
      MIN_VALUE: errors.ptBr.tra.MIN_VALUE
    });
  }
}

module.exports = TransferValueValidationService;
